import axios from "axios";

// console.log(process.env.NODE_ENV)
console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV != "production") {
  axios.defaults.baseURL = "http://central.acingame.com";
}
const login = "/system_info"; //登录接口
//用户管理
const getUserInfo = "/admin_api/user/list"; //用户管理列表
const getUserDetial = "/admin_api/user/get_info"; //用户编辑详情
const editUser = "/admin_api/user/edit"; //用户编辑保存
//角色管理
const getRoleInfo = "/admin_api/role/list"; //角色列表
const addRole = "/admin_api/role/add"; //角色添加
const editRole = "/admin_api/role/edit"; //角色编辑
const deleteRole = "/admin_api/role/destroy"; //角色删除
const getRoleUserInfo = "/admin_api/role/get_user"; //角色成员列表
const getRoleUserSearch = "/admin_api/role/search_user"; //角色成员搜索
const addRoleUser = "/admin_api/role/save_user"; //角色成员添加
const getRoleAuthInfo = "/admin_api/role/get_permissions"; //角色权限详情
const addRoleAuthInfo = "/admin_api/role/save_permissions"; //编辑角色权限
const selectRole = "/admin_api/role/select"; //选择角色
const deleteRoleUser = "/admin_api/role/remove_user"; //角色成员移除
//公司管理
const getCompanyInfo = "/admin_api/company/list"; //列表
const companyEdit = "/admin_api/company/edit"; //编辑
const companyAdd = "/admin_api/company/add"; //添加
//平台管理
const getPlatformInfo = "/admin_api/platform/list"; //平台列表
const getPlatUserInfo = "/admin_api/platform/get_user"; //平台用户管理
const addPlatUser = "/admin_api/platform/save_user"; //平台用户添加
const deletePlatUser = "/admin_api/platform/destroy"; //平台删除
const removePlatUser = "/admin_api/platform/remove_user"; //平台用户添加
const getPlatUserSearch = "/admin_api/platform/search_user"; //平台用户搜索
const platformFileUp = "/upload/file"; //平台logo上传
const getPlatformdEditInfo = "/admin_api/platform/get_info"; //平台编辑列表获取
const editPlatform = "/admin_api/platform/edit"; //平台编辑
const addPlatform = "/admin_api/platform/add"; //平台添加
const selectPlatform = "/admin_api/platform/select"; //选择平台
const platformAuth = "/admin_api/platform/edit_platform_auth"; //获取平台权限编辑
const saveRole = "/admin_api/platform/save_role"; //平台添加角色
//权限管理
const getauthInfo = "/admin_api/auth/list"; //权限列表
const addAuthInfo = "/admin_api/auth/add"; //添加权限
const editAuthInfo = "/admin_api/auth/edit"; //编辑权限
const deleteAuthInfo = "/admin_api/auth/destroy"; //删除权限
//部门管理
const getDepartmentInfo = "/admin_api/org/list"; //部门列表
const getDepartCompany = "/admin_api/company/select"; //部门内的公司信息
const addDepartment = "/admin_api/org/add"; //部门添加
const editDepartment = "/admin_api/org/edit"; //部门编辑
//岗位管理
const getPositionInfo = "/admin_api/position/list"; //岗位信息
const getEditInfo = "/admin_api/position/get_info"; //岗位选择
const editPosition = "/admin_api/position/edit"; //岗位编辑
//操作日志
const actionList = "/footprint/action/event/list"; //
const actionEvent = "/footprint/action/event"; //
const actionDetail = "/footprint/action/event/detail"; //
const platformList = "/footprint/platform/list"; //

export default {
  platformList,
  login,
  getUserInfo,
  getUserDetial,
  getRoleInfo,
  addRole,
  editRole,
  getRoleUserInfo,
  getRoleUserSearch,
  addRoleUser,
  deleteRole,
  deleteRoleUser,
  getCompanyInfo,
  companyEdit,
  companyAdd,
  getPlatformInfo,
  getPlatUserInfo,
  addPlatUser,
  deletePlatUser,
  getPlatUserSearch,
  platformFileUp,
  getPlatformdEditInfo,
  editPlatform,
  addPlatform,
  getauthInfo,
  addAuthInfo,
  editAuthInfo,
  getRoleAuthInfo,
  addRoleAuthInfo,
  deleteAuthInfo,
  getDepartmentInfo,
  getDepartCompany,
  addDepartment,
  editDepartment,
  selectRole,
  selectPlatform,
  editUser,
  getPositionInfo,
  getEditInfo,
  editPosition,
  removePlatUser,
  platformAuth,
  saveRole,
  actionList,
  actionEvent,
  actionDetail,
};
